export default __webpack_public_path__ + "static/media/pesquisa_documento.15e4bf32.svg";